module.exports = __webpack_public_path__ + "img/35.de474c4a.jpg";